import { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";
import { cn } from "@/lib/utils";
import { Sheet, SheetContent } from "@/components/ui/sheet";
const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background dark:bg-black">
      {/* Desktop sidebar — full viewport height */}
      <div className="hidden lg:block">
        <AdminSidebar collapsed={collapsed} />
      </div>

      {/* Mobile sidebar sheet */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-[232px] border-r border-neutral-800 bg-black p-0 [&>button]:hidden">
          <AdminSidebar collapsed={false} mobile onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main column — topbar + content */}
      <div
        className={cn(
          "flex min-h-screen min-w-0 flex-col transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]",
          collapsed ? "lg:ml-[68px]" : "lg:ml-[216px]"
        )}
      >
        <AdminTopbar
          collapsed={collapsed}
          onToggleSidebar={() => setCollapsed(!collapsed)}
          onMobileMenuToggle={() => setMobileOpen(true)}
        />

        <main className="min-w-0 flex-1 overflow-x-clip p-3 sm:p-4 lg:p-6 xl:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
